import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineDeleteForever } from "react-icons/md";

import { useSnack } from "../../../hooks/useSnack";
import classroomServices from "../../../services/classroomServices";
import Button from "../../Button";
import Modal from "../../Modal";

const DeleteClassroomModal = forwardRef(({ onSubmit }, ref) => {
  const { t } = useTranslation();
  const { showSnack } = useSnack();

  const [isOpen, setIsOpen] = useState(false);
  const [classroomName, setClassroomName] = useState("");
  const [classroomID, setClassroomID] = useState("");
  const [studentCount, setStudentCount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal(classroom) {
      setClassroomID(classroom?.classroom?.id || classroom?.id);
      setClassroomName(classroom?.classroom?.name || classroom?.name);
      setStudentCount(classroom?.classroom?.student_count || classroom?.student_count);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      const res = await classroomServices.deleteClassroom(classroomID);
      showSnack(res.message, "success");
      onSubmit();
      setIsOpen(false);
      setTimeout(() => {
        setIsSubmitting(false);
      }, 500);
    } catch (error) {
      setIsSubmitting(false);
      showSnack(error, "error");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      header={
        <div className="flex items-center justify-between">
          <p className="flex items-center gap-2 text-red-500">
            <MdOutlineDeleteForever size={22} className="text-red-500" />
            {t("delete")} {t("classroom")}
          </p>
        </div>
      }
      footer={
        <div className="flex items-center justify-end space-x-2">
          <Button color="white" variant="outlined" onClick={() => setIsOpen(false)} label={t("cancel")} />
          <Button
            className="w-36"
            color="red"
            disabled={isSubmitting}
            loading={isSubmitting}
            onClick={handleConfirm}
            label={t("delete")}
          />
        </div>
      }
    >
      {/* Modal Body Content */}
      <div className="flex items-center justify-between gap-6">
        <p className="text-start text-mutedText dark:text-dark-mutedText">
          {t("are_you_sure")} {t("delete")}{" "}
          <strong>
            {classroomName} {t("question_mark")}
          </strong>
          <br />
          {studentCount == 0 ? (
            <span> {t("all_of_your_data_will_be_permanently_removed_2")}</span>
          ) : (
            <span> {t("all_of_your_data_will_be_permanently_removed")}</span>
          )}
        </p>
      </div>
    </Modal>
  );
});

export default DeleteClassroomModal;
